import { createShallowStore, createStoreWithPersistAndSubscribe } from '@frontend/store';

interface IntegrationsDashboardStore {
  isUserAuthenticated: boolean;
  isUserLoggingIn: boolean;
  isUserRefreshing: boolean;
  // Map of migration id -> `migratedAt` timestamp. Hydrated from the
  // ListMigrations response because GetMigrationByID does not return this field.
  migratedAtById: Record<string, string | undefined>;
  setIsUserAuthenticated: (isAuthenticated: boolean) => void;
  setIsUserLoggingIn: (isClicked: boolean) => void;
  setIsUserRefreshing: (isRefreshing: boolean) => void;
  setMigratedAtEntries: (entries: Array<{ id?: string; migratedAt?: string }>) => void;
  resetState: () => void;
}

const initialState = {
  isUserAuthenticated: false, //True if user is authenticated, false otherwise.
  isUserLoggingIn: false, //True when login process starts, false when it ends.
  isUserRefreshing: false, //True when user triggers a data refresh, false when it ends.
  migratedAtById: {} as Record<string, string | undefined>,
};

export const useIntegrationsDashboardStore = createStoreWithPersistAndSubscribe<IntegrationsDashboardStore>(
  (set) => ({
    ...initialState,
    setIsUserAuthenticated: (isAuthenticated: boolean) => {
      set({ isUserAuthenticated: isAuthenticated });
    },
    setIsUserLoggingIn: (isClicked: boolean) => {
      set({ isUserLoggingIn: isClicked });
    },
    setIsUserRefreshing: (isRefreshing: boolean) => {
      set({ isUserRefreshing: isRefreshing });
    },
    setMigratedAtEntries: (entries) => {
      set((state) => {
        const next = { ...state.migratedAtById };
        let changed = false;
        for (const { id, migratedAt } of entries) {
          if (!id) continue;
          if (next[id] !== migratedAt) {
            next[id] = migratedAt;
            changed = true;
          }
        }
        return changed ? { migratedAtById: next } : state;
      });
    },
    resetState: () => {
      set(initialState);
    },
  }),
  {
    name: 'IntegrationsDashboard',
  },
  {
    name: 'IntegrationsDashboardStore',
    enabled: true,
  }
);

export const useIntegrationsDashboardShallowStore =
  createShallowStore<IntegrationsDashboardStore>(useIntegrationsDashboardStore);
